import { defineView } from "@/ReactSetup/view-definitions";
import { systemListActions } from "ReactReducers/SystemList/system-list-reducer";

const definition = defineView({
    name: "SystemCardList",
    component: () => (__SERVER__ ? require("./system-card-list-view") : import("./system-card-list-view")),
    setup: payload => {
        return systemListActions.init(payload);
    }
});

export default definition;
